export default function formatId ( id )
{
    return id.indexOf ( 'owner' ) !== -1 ? id.split ( '-' ).slice ( 0, 2 ).join ( '-' ) : id;
}